import React, { useEffect, useRef, useState } from "react";
import FormCreator from "../../../../../../components/forms/FormCreator";
import { clientvaluationDetailDataGridConfig, clientValuationDetailsDataFormConfig } from "./clientValuationDetailsData.formfields.config";
import MolGrid from "../../../../../../components/molGrid/MolGrid";
import Buttons from "../../../../../../components/ui/button/Buttons";
import { useGetAllMergeFieldsDataMutation, useUpdateAllReportFieldMutation, useUpdateCalculationReportFieldMutation, useUpdateCopyReportFieldMutation, useUpdateImportReportFieldMutation, useUpdateUserEntryReportFieldMutation } from "../../../../../../app/services/ClientAPI";
import {
  useGetAllMasterFieldCategoriesMutation,
  useGetAllOriginMutation,
} from "../../../../../../app/services/MasterValuationFieldsAPI";
import { mapDropdownOptions } from "../../../../../../components/forms/libs/data/mapDropdownOptions";
import { useGetClientValuationByReportWordTempIdMutation, useGetClientValuationByReportXmlTempIdMutation, useLazyCreateWordMergeQuery, useLazyExportCsvQuery, usePerformCalculationMutation, usePriorFromCopyFieldsMutation } from "../../../../../../app/services/clientValuationAPI";
import CenterModal from "../../../../../../components/ui/centerModal/CenterModal";
import ManageXMLReportData from "./ManageXMLReportData";
import ImportLiabilities from "./components/ImportLiabilities";
import SwalAlert from "../../../../../../services/swalService/SwalService";
import ToastService from "../../../../../../services/toastService/ToastService";
import DataLoader from "../../../../../../components/molGrid/ui/dataLoader/DataLoader";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import NoRecordFound from "../../../../../../components/molGrid/ui/noRecordFound/NoRecordFound";
import moment from "moment";
import PropTypes from "prop-types";
import { propTypes } from "react-bootstrap/esm/Image";


const ValuationData = (props) => {
  const inputRefs = useRef({}); // Store refs for input elements
  const cellRefs = useRef({}); // Store refs for cell elements
  const activeInputRef = useRef(null);
  const clientRef = useRef(null);
  const molGridRef = useRef();
  const containerRef = useRef(null);
  const [clientForm, setClientForm] = useState(clientValuationDetailsDataFormConfig);
  const [gridConfig, setGridConfig] = useState(clientvaluationDetailDataGridConfig)
  const [formValues, setFormValues] = useState({});
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [wordDocPathAndName, setWordDocPathAndName] = useState(null);
  const { error, success } = SwalAlert();
  const [XmlReportId, setXmlReportId] = useState();
  const [originOptions, setOriginOptions] = useState([])
  const [dataSource, setDataSource] = useState([]);
  const [isManageXMLReportModelOpen, setIsManageXMLReportModelOpen] = useState(false);
  const [isManageXMLReportPrimeModelOpen, setIsManageXMLReportPrimeModelOpen] = useState(false);
  const [selectedOrigin, setSelectedOrigin] = useState()
  const [selectedCategory, setSelectedCategory] = useState();
  const [isImportLiabilitysModelOpen, setIsImportLiabilityModelOpen] = useState(false);
  const [calculationLoader, setCalculationLoader] = useState(false)
  // prime 
  const [selectedRow, setSelectedRow] = useState({});
  const editableFields = ['valFieldValue', "xmlOverrideValueField", "valFieldOverride", "copiedValue"];
  const [valuationdata, setValuationdata] = useState()
  const [isloadingData, setIsloadingData] = useState(true);
  const [sortState, setSortState] = useState([]);
  const { confirm } = SwalAlert();
  const [nextEditTarget, setNextEditTarget] = useState(null);

  const [
    getAllMergeFieldsData,
    {
      isFetching: isGetAllMergeFieldsDataFetching,
      isLoading: isGetAllMergeFieldsDataLoading,
      isSuccess: isGetAllMergeFieldsDataSuccess,
      data: getMergeFieldsData,
    },
  ] = useGetAllMergeFieldsDataMutation();

  const [getAllOrigin, {
    isLoading: isAllOriginLoading,
    isSuccess: isAllOriginSuccess,
    data: allOriginData,
  },
  ] = useGetAllOriginMutation();

  const [getAllMasterFieldCategories,
    {
      isLoading: isAllMasterFieldCategoriesListLoading,
      isSuccess: isAllMasterFieldCategoriesListSuccess,
      data: allMasterFieldCategoriesData,
    },
  ] = useGetAllMasterFieldCategoriesMutation();

  const [getClientValuationsListByReportTempId,
    {
      isFetching: isGetClientValuationsByReportTempIdFetching,
      isSuccess: isGetClientValuationByReportTempIdSuccess,
      data: clientValuationByReportTempIdData,
    },
  ] = useGetClientValuationByReportWordTempIdMutation();

  const [getClientValuationsListByReportXmlTempId,
    {
      isFetching: isGetClientValuationsByReportXmlTempIdFetching,
      isSuccess: isGetClientValuationByReportXmlTempIdSuccess,
      data: clientValuationByReportXmlTempIdData,
    },
  ] = useGetClientValuationByReportXmlTempIdMutation();

  const [priorFromCopyFields, {
    isLoading: ispriorFromCopyFields,
    isSuccess: ispriorFromCopyFieldsSuccess,
    isError: ispriorFromCopyFieldsError,
    data: priorFromCopyFieldsData,
    error: priorFromCopyFieldsDataError
  }] = usePriorFromCopyFieldsMutation()

  const [updateAllReportField, {
    isLoading: isAllReportFieldUpdating,
    isSuccess: isAllReportFieldUpdated,
    data: reportFieldUpdatedData,
  }] = useUpdateAllReportFieldMutation();

  const [updateCopyReportField, {
    isLoading: isCopyReportFieldUpdating,
    isSuccess: isCopyReportFieldUpdated,
    data: copyFieldUpdatedData,
  }] = useUpdateCopyReportFieldMutation();

  const [updateCalculationReportField, {
    isLoading: isCalculationReportFieldUpdating,
    isSuccess: isCalculationReportFieldUpdated,
    data: calculationReportFieldUpdatedData,
  }] = useUpdateCalculationReportFieldMutation();

  const [updateImportReportField, {
    isLoading: isImportReportFieldUpdating,
    isSuccess: isImportReportFieldUpdated,
    data: importReportFieldUpdatedData,
  }] = useUpdateImportReportFieldMutation();

  const [updateUserEntryReportField, {
    isLoading: isUserEntryReportFieldUpdating,
    isSuccess: isUserEntryReportFieldUpdated,
    data: userEntryReportFieldUpdatedData,
  }] = useUpdateUserEntryReportFieldMutation();

  const [performCalculation, {
    isLoading: isPerformCalculationFetching,
    isSuccess: isPerformCalculationSuccess,
    isError: isPerformCalculationError,
    data: performCalculationData,
    error: performCalculationDataError
  }] = usePerformCalculationMutation()


  const [createWordMerge, {
    isLoading: isCreatingWordMerge,
    isFetching: isFetchingWordMerge,
    isError: isWordMergeError,
    isSuccess: isWordMergeSuccess,
    data: isWordMergeData,
  }] = useLazyCreateWordMergeQuery();

   const [exportCsv, {
    isLoading: isExportCsv,
    isFetching: isFetchingExportCsv,
    isError: isExportCsvError,
    isSuccess: isExportCsvSuccess,
    data: ExportCsvData,

  }] = useLazyExportCsvQuery()

  const handleShowResultClick = () => {
    let formData = clientRef?.current?.getFormData();
    let selectedOrigin = formData?.originId?.value ? formData?.originId?.value : formData?.originId;
    let fieldsToHide = ["XML Override Value Field", "valFieldName", "ValfieldValue", "ValFieldMergeFieldName", "Override Value", "ReportTemplateID", "ReportTemplateFieldID", "ValfieldId"];
    switch (selectedOrigin) {
      case 1:
        fieldsToHide = ["Copy Value", "XML Override Value Field", "valfieldName", "ValfieldValue", "ValFieldMergeFieldName", "ReportTemplateID", "ReportTemplateFieldID", "ValfieldId"];
        break;
      case 2:
        fieldsToHide = ["Field Value", "Field Name", "Merge Field Name", "XML Override Value Field", "Copy Value"];
        break;
      case 3:
        fieldsToHide = ["ValFieldMergeFieldName", "valfieldName", "Field Value", "XML Override Value Field", "valFieldName", "ValfieldValue", "ValFieldMergeFieldName", "ReportTemplateID", "ReportTemplateFieldID", "ValfieldId"];
        break;
      case 4:
        fieldsToHide = ["valfieldName", "ValfieldValue", "ValFieldMergeFieldName", "XML Override Value Field", "ReportTemplateID", "ReportTemplateFieldID", "ValfieldId", "Copy Value"];
        break;
      default:
        fieldsToHide = ["valfieldName", "ValfieldValue", "ValFieldMergeFieldName", "ReportTemplateID", "ReportTemplateFieldID", "ValfieldId", "Copy Value"];
    }

    const filteredColumns = clientvaluationDetailDataGridConfig.columns.filter(
      (item) => !fieldsToHide.includes(item.name)
    );
    setGridConfig((prevConfig) => ({
      ...prevConfig,
      columns: filteredColumns
    }));

    // const requestData = {
    //   templateid: props.selectedTemplate,
    //   category: formData?.category.label ? formData?.category.label : "All",
    //   valid: props.valID,
    //   originId: formData?.originId?.label ? formData?.originId?.label : "All"
    // };
    // getAllMergeFieldsData(requestData);
    // setSelectedOrigin(formData?.originId);
    getOriginData()
  };

  const handleManageXMLReportClick = () => {
    setIsManageXMLReportModelOpen(true);
  };
  const handleManagePrimeXMLReportClick = () => {
    setIsManageXMLReportPrimeModelOpen(true);
  }
  const handleImportLiabilitysClick = () => {
    setIsImportLiabilityModelOpen(true);
  };
  const handleCloseModel = () => {
    // setIsManageXMLReportModelOpen(false);
    setIsManageXMLReportPrimeModelOpen(false)
    setSelectedOrigin({})
  };
  const handleCloseImportModel = () => {
    setIsImportLiabilityModelOpen(false);
  }
  const handleCopyValDataClick = () => {
    let request = {
      ValID: props?.valID,
      ReportTemplateID: props?.selectedTemplate,
      CopyValID: props?.valCopyId
    }
    confirm(
      "Copy?",
      "Are you sure you want to Copy?",
      "Yes",
      "No"
    ).then((confirmed) => {
      if (confirmed) {
        if (request) {
          priorFromCopyFields(request).then(r => {
            // handleShowResultClick();
          });
        };
      }
    });
  }

  const handleUpdateClick = (updateData, rowIndexToUpdate) => {
    const originId = selectedOrigin?.value;
    const request = {
      ValID: props.valID,
      valFieldValue: originId.value === 3 ? updateData?.copiedValue : updateData?.valFieldValue,
      valFieldOverride: updateData?.valFieldOverride,
      reportFieldID: updateData?.reportFieldID,
      reportTemplateFieldID: updateData?.reportTemplateFieldID
    };

    if (originId === 4) {
      updateCalculationReportField(request);
    } else if (originId === 3) {
      updateCopyReportField(request);
    } else if (originId === 2) {
      updateImportReportField(request);
    } else if (originId === 1) {
      updateUserEntryReportField(request);
    } else {
      request.xmlOverrideValueField = updateData?.xmlOverrideValueField;
      updateAllReportField(request);
    }
  };

  const getOriginData = () => {
    const formData = clientRef?.current?.getFormData()
    const requestData = {
      templateid: props?.selectedTemplate,
      category: selectedCategory?.label ? selectedCategory?.label : "All",
      valid: props?.valID,
      originId: selectedOrigin?.label ? selectedOrigin?.label : "All",
    };
    getAllMergeFieldsData(requestData);
  }

  const sortData = (data, sortState) => {

    return [...data].sort((a, b) => {
      for (const sort of sortState) {
        const valA = a[sort.column] ?? '';
        const valB = b[sort.column] ?? '';
        const comparison = sort.direction === 'asc'
          ? valA.toString().localeCompare(valB.toString())
          : valB.toString().localeCompare(valA.toString());
        if (comparison !== 0) return comparison;
      }
      return 0;
    });
  };

  const handleSortingChange = async (sortString, col) => {
    if (!sortString) return;
    const newSortState = sortString
      .split(',')
      .map(item => {
        const [column, directionRaw] = item.trim().split(/\s+/);
        const direction = directionRaw?.toLowerCase() === 'desc' ? 'desc' : 'asc';
        return { column, direction };
      })
      .filter(item => item.column);
    const filtered = newSortState.filter(item => item.column === col.fieldName);
    setSortState(newSortState);
    const orderData = await sortData(dataSource, filtered);
    setDataSource(orderData);
  };


  const onColumnChange = (dataField, newRowData, updatedData) => {
    let form = { ...clientForm };

    if (dataField == "originId") {
      setSelectedOrigin(newRowData?.originId)
    }
    if (dataField == "category") {
      setSelectedCategory(newRowData?.category)
    }
    if (newRowData) {
      form.initialState = {
        originId: newRowData?.originId?.value ? newRowData?.originId?.value : newRowData?.originId,
        category: newRowData?.category?.value ? newRowData?.category?.value : newRowData?.category,
        wordDocID: newRowData?.wordDocID?.value ? newRowData?.wordDocID?.value : newRowData?.wordDocID,
        xmlReportId: newRowData?.xmlReportId?.value ? newRowData?.xmlReportId?.value : newRowData?.xmlReportId
      }
    }
    setClientForm(form);
    if (dataField === "wordDocID" && newRowData?.wordDocID?.value != null) {
      setWordDocPathAndName(newRowData?.wordDocID);
    }
    if (dataField === "xmlReportId" && newRowData?.xmlReportId?.value != null) {
      setXmlReportId(newRowData.xmlReportId.value);
    }
  };


  const handlePerformCalculation = () => {
    let req = {
      valuationId: props.valID,
      reportTemplateId: props.selectedTemplate
    }
    performCalculation(req)
  }

  const handleCreateMergeClick = () => {
    const docName = `${props.clientName}.${props.PlanNumber}.${props.reportType}.${moment(props.planYearBegin).format("YYYYMMDD")}.doc`;
    const req = {
      valID: props.valID,
      wordDocPathAndName: wordDocPathAndName && typeof wordDocPathAndName === 'object' ? wordDocPathAndName?.label : wordDocPathAndName,
      outFileName: docName.replace(/[^a-zA-Z0-9.]/g, ''),
      WordTemplId:clientForm?.initialState?.wordDocID
    }
    createWordMerge(req);
  }

  const handleExportCsc =()=>{
    const docName = `${props.clientName}.${props.PlanNumber}.${props.reportType}.${moment(props.planYearBegin).format("YYYYMMDD")}.doc`;
    const req = {
      valID: props.valID,
      wordDocPathAndName: wordDocPathAndName && typeof wordDocPathAndName === 'object' ? wordDocPathAndName?.label : wordDocPathAndName,
      outFileName: docName.replace(/[^a-zA-Z0-9.]/g, ''),

    }    
    exportCsv(req);
  }

  const handleShowUpdate = (data) => {
    setGridConfig(prev => ({
      ...prev,
      allowEditDoubleClick: !prev.allowEditDoubleClick,
    }));
  }

  //  prime function  
    // Cell renderer to make cells clickable and store refs
    const cellRenderer = (rowData, options) => {
      const { rowIndex, field } = options;
      const key = `${rowIndex}-${field}`;
      return (
        <span
          ref={(el) => (cellRefs.current[key] = el)}
          style={{ cursor: 'pointer', display: 'block', width: '100%' }}
        >
          {rowData[field] ?? ''}
        </span>
      );
    };

  const handleEditorKeyDown = (e, rowIndex, field, value, editorCallback) => {
    if (e.key === 'Enter') {
      e.preventDefault();
  
      // Ensure the value is not modifying a read-only property
      try {
        editorCallback(value); // Call editorCallback with the new value
      } catch (error) {
        console.error('Error in editorCallback:', error);
      }
  
      // Prevent PrimeReact auto-edit flicker
      if (activeInputRef.current) {
        activeInputRef.current.blur();
        activeInputRef.current = null;
      }
  
      // Move to next row, same column
      const nextRow = rowIndex + 1;
      if (nextRow < dataSource.length) {
        setNextEditTarget({ rowIndex: nextRow, field });
      }
    }
  };

  const handleFieldEditor = (options) => {
    const { rowIndex, field, value, editorCallback } = options;
    const key = `${rowIndex}-${field}`;

    // Validate editableFields and field
  if (!Array.isArray(editableFields) || !editableFields.includes(field)) {
    return <>{options?.value ?? ''}</>;
  }
 

    return (
      <InputText
        ref={(el) => {
          inputRefs.current[key] = el;
          if (el) {
            activeInputRef.current = el;
            setTimeout(() => el.focus(), 0);
          }
        }}
        type="text"
        value={value ?? ''}
        // onChange={(e) => editorCallback(e.target.value)}
        onChange={(e) => {
          try {
            editorCallback(e.target.value); // Update value via editorCallback
          } catch (error) {
            console.error('Error updating value:', error);
          }
        }}
        onKeyDown={(e) =>
          handleEditorKeyDown(
            e,
            rowIndex,
            field,
            e.target.value,
            editorCallback
          )
        }
      />
    );
  };

  const onCellEditComplete = (e) => {
    const { rowData, newValue, field, rowIndex ,value,newRowData } = e;

    let changeValue = value == null ? "" :value
    if ((newValue != null && newValue != changeValue) && (newValue != value) ) {
      handleUpdateClick(newRowData)
    }
 };

  useEffect(() => {
    if (nextEditTarget) {
      const { rowIndex, field } = nextEditTarget;
      const key = `${rowIndex}-${field}`;
      const cell = cellRefs.current[key];

      if (cell) {
        setTimeout(() => {
          cell.click(); // Trigger edit mode
        }, 50);
      }

      setNextEditTarget(null); // reset target
    }
  }, [nextEditTarget]);

  useEffect(() => {
    getAllOrigin()
    getAllMasterFieldCategories()
    getClientValuationsListByReportTempId(props.selectedTemplate)
    getClientValuationsListByReportXmlTempId(props.selectedTemplate)
  }, []);

  useEffect(() => {
    if (isFetchingWordMerge) {
      setCalculationLoader(true);

      if (containerRef.current) {
        containerRef.current.style.pointerEvents = "none";
      }

      return;
    }

    if (isWordMergeError) {
      error("No Record Found").then((confirmed) => {
        if (confirmed) {
          setCalculationLoader(false);

          if (containerRef.current) {
            containerRef.current.style.pointerEvents = "auto";
          }
        }
      });
    }

    if (!isFetchingWordMerge && isWordMergeData) {
      const message = isWordMergeData?.errorMessage || "";
      const dialog = isWordMergeData?.blobUrl
        ? success("Record Download", message)
        : error("", "No Record Found");

      dialog.then((confirmed) => {
        if (confirmed) {
          setCalculationLoader(false);

          if (containerRef.current) {
            containerRef.current.style.pointerEvents = "auto";
          }
        }
      });
    }

    if (!isFetchingWordMerge && isWordMergeSuccess && isWordMergeData) {
      if (isWordMergeData.blobUrl && isWordMergeData.contentType) {
        //const docName = `${props.clientName}.${props.PlanNumber}.${props.reportType}.${moment(props.planYearBegin).format("YYYYMMDD")}.doc`;
        const docName = isWordMergeData.fileName;

        const fileURL = isWordMergeData.blobUrl;
        const link = document.createElement("a");
        link.href = fileURL;
        //link.download = docName.replace(/[^a-zA-Z0-9.]/g, '');
        link.download = docName;
        // link.download =
        //   wordDocPathAndName && typeof wordDocPathAndName === "object"
        //     ? wordDocPathAndName.label
        //     : isWordMergeData?.fileName || "Word_Document";
        document.body.appendChild(link);
        link.click();
        link.remove();

        URL.revokeObjectURL(fileURL);
      }
    }
  }, [
    isCreatingWordMerge,
    isFetchingWordMerge,
    isWordMergeSuccess,
    isWordMergeData,
    isWordMergeError,
  ]);

   useEffect(() => {
    if (isFetchingExportCsv) {
      setCalculationLoader(true);

      if (containerRef.current) {
        containerRef.current.style.pointerEvents = "none";
      }

      return;
    }

    if (isExportCsvError) {
      error("No Record Found").then((confirmed) => {
        if (confirmed) {
          setCalculationLoader(false);

          if (containerRef.current) {
            containerRef.current.style.pointerEvents = "auto";
          }
        }
      });
    }

    if (!isFetchingExportCsv && ExportCsvData) {
      const message = ExportCsvData?.errorMessage || "";
      const dialog = ExportCsvData?.blobUrl
        ? success("Record Download", message)
        : error("", "No Record Found");

      dialog.then((confirmed) => {
        if (confirmed) {
          setCalculationLoader(false);

          if (containerRef.current) {
            containerRef.current.style.pointerEvents = "auto";
          }
        }
      });
    }

    if (!isFetchingExportCsv && isExportCsvSuccess && ExportCsvData) {
      if (ExportCsvData.blobUrl && ExportCsvData.contentType) {
        //const docName = `${props.clientName}.${props.PlanNumber}.${props.reportType}.${moment(props.planYearBegin).format("YYYYMMDD")}.doc`;
        const docName = ExportCsvData.fileName;

        const fileURL = ExportCsvData.blobUrl;
        const link = document.createElement("a");
        link.href = fileURL;
        //link.download = docName.replace(/[^a-zA-Z0-9.]/g, '');
        link.download = docName;
        // link.download =
        //   wordDocPathAndName && typeof wordDocPathAndName === "object"
        //     ? wordDocPathAndName.label
        //     : isWordMergeData?.fileName || "Word_Document";
        document.body.appendChild(link);
        link.click();
        link.remove();

        URL.revokeObjectURL(fileURL);
      }
    }
  }, [
    isExportCsv,
    isFetchingExportCsv,
    isExportCsvSuccess,
    ExportCsvData,
    isExportCsvError,
  ]);


  useEffect(() => {
    if (isPerformCalculationFetching && containerRef.current) {
      containerRef.current.style.pointerEvents = "none";
    } else if (containerRef.current) {
      containerRef.current.style.pointerEvents = "auto";
    }
  }, [isPerformCalculationFetching]);

  useEffect(() => {
    if (isPerformCalculationFetching) {

      setCalculationLoader(true);

      if (containerRef.current) {
        containerRef.current.style.pointerEvents = "none";
      }
      return;
    }

    if (isPerformCalculationError) {
      const message = JSON.parse(performCalculationDataError.data.responseData)
      error(message?.errorMessage, "", true)
        .then((confirmed) => {
          if (confirmed) {
            setCalculationLoader(false);

            if (containerRef.current) {
              containerRef.current.style.pointerEvents = "auto";
            }
          }
        });
    }

    if (!isPerformCalculationFetching && performCalculationData) {
      const message = performCalculationData.errorMessage || "";
      const dialog = message.includes('No changes made')
        ? error("", message)
        : success("", message);
      dialog.then((confirmed) => {
        if (confirmed) {
          setCalculationLoader(false);
          getOriginData()
          if (containerRef.current) {
            containerRef.current.style.pointerEvents = "auto";
          }
        }
      });
    }
  }, [isPerformCalculationFetching, performCalculationData]);

  useEffect(() => {
    if (isAllReportFieldUpdated && reportFieldUpdatedData) {
      const msg = reportFieldUpdatedData?.errorMessage ?? "";

      if (msg.includes("NO RECORD FOUND") || msg.includes("exist") || msg.includes("No changes made")) {
        ToastService.warning(msg);
      } else {
        ToastService.success(reportFieldUpdatedData.errorMessage);
        props.onSuccess?.();
        getOriginData();
      }
    }
  }, [isAllReportFieldUpdated, reportFieldUpdatedData]);

  useEffect(() => {
    if (ispriorFromCopyFields && containerRef.current) {
      containerRef.current.style.pointerEvents = "none";
    } else if (containerRef.current) {
      containerRef.current.style.pointerEvents = "auto";
    }
  }, [ispriorFromCopyFields]);

  useEffect(() => {
    if (ispriorFromCopyFields) {

      setCalculationLoader(true);

      if (containerRef.current) {
        containerRef.current.style.pointerEvents = "none";
      }
      return;
    }

    if (ispriorFromCopyFieldsError) {
      const message = JSON.parse(priorFromCopyFieldsDataError?.data?.responseData)
      error(message?.errorMessage, "", true)
        .then((confirmed) => {
          if (confirmed) {
            setCalculationLoader(false);

            if (containerRef.current) {
              containerRef.current.style.pointerEvents = "auto";
            }
          }
        });
    }

    if (!ispriorFromCopyFields && priorFromCopyFieldsData) {
      const message = priorFromCopyFieldsData.errorMessage || "";
      const dialog = message.includes('No changes made')
        ? error("", message)
        : success("", message);
      dialog.then((confirmed) => {
        if (confirmed) {
          setCalculationLoader(false);
          getOriginData()
          if (containerRef.current) {
            containerRef.current.style.pointerEvents = "auto";
          }
        }
      });
    }
  }, [ispriorFromCopyFields, priorFromCopyFieldsData]);

  useEffect(() => {
    if (isCopyReportFieldUpdated && copyFieldUpdatedData) {
      const msg = copyFieldUpdatedData?.errorMessage ?? "";

      if (msg.includes("NO RECORD FOUND") || msg.includes("exist") || msg.includes("No changes made")) {
        ToastService.warning(msg);
      } else {
        ToastService.success(copyFieldUpdatedData.errorMessage);
        props.onSuccess?.();
        getOriginData()
      }
    }
  }, [isCopyReportFieldUpdated, copyFieldUpdatedData]);

  useEffect(() => {
    if (isCalculationReportFieldUpdated && calculationReportFieldUpdatedData) {
      const msg = calculationReportFieldUpdatedData?.errorMessage ?? "";

      if (msg.includes("NO RECORD FOUND") || msg.includes("exist") || msg.includes("No changes made")) {
        ToastService.warning(msg);
      } else {
        ToastService.success(calculationReportFieldUpdatedData.errorMessage);
        props.onSuccess?.();
        getOriginData()
      }
    }
  }, [isCalculationReportFieldUpdated, calculationReportFieldUpdatedData]);

  useEffect(() => {
    if (isImportReportFieldUpdated && importReportFieldUpdatedData) {
      const msg = importReportFieldUpdatedData?.errorMessage ?? "";

      if (msg.includes("NO RECORD FOUND") || msg.includes("exist") || msg.includes("No changes made")) {
        ToastService.warning(msg);
      } else {
        ToastService.success(importReportFieldUpdatedData.errorMessage);
        props.onSuccess?.();
        getOriginData()
      }
    }
  }, [isImportReportFieldUpdated, importReportFieldUpdatedData]);

  useEffect(() => {
    if (isUserEntryReportFieldUpdated && userEntryReportFieldUpdatedData) {
      const msg = userEntryReportFieldUpdatedData?.errorMessage ?? "";

      if (msg.includes("NO RECORD FOUND") || msg.includes("exist") || msg.includes("No changes made")) {
        ToastService.warning(msg);
      } else {
        ToastService.success(userEntryReportFieldUpdatedData.errorMessage);
        props.onSuccess?.();
        getOriginData()
      }
    }
  }, [isUserEntryReportFieldUpdated, userEntryReportFieldUpdatedData]);

  useEffect(() => {
    if (isGetAllMergeFieldsDataSuccess && getMergeFieldsData) {
      if (getMergeFieldsData) {
        setDataSource(getMergeFieldsData);
        setIsloadingData(
          isGetAllMergeFieldsDataLoading && getMergeFieldsData.length < 0
            ? true
            : false
        );
        setValuationdata(getMergeFieldsData.length > 0)
      }
    }
  }, [isGetAllMergeFieldsDataSuccess, getMergeFieldsData]);

  useEffect(() => {
    if (isAllOriginSuccess && allOriginData) {
      const allCategorie = {
        label: "All",
        value: "All",
      };
      const categoryOptions = allOriginData.map((item) => ({
        label: item.originType,
        value: item.originId,
      }));

      const updatedCategories = [allCategorie, ...categoryOptions].sort((a, b) =>
        a?.label.localeCompare(b?.label)
      );
      setOriginOptions(updatedCategories)
      mapDropdownOptions(
        clientValuationDetailsDataFormConfig,
        "basicDetailSection",
        "originId",
        updatedCategories,
        "value",
        "label"
      );
      setSelectedOrigin(updatedCategories[0])
      let updatedForm = { ...clientForm };
      updatedForm.initialState = {
        ...updatedForm.initialState,
        originId: allOriginData[0]?.originId || null,
        originType: allOriginData[0].originType,
      };
    }
  }, [isAllOriginSuccess, allOriginData]);

  useEffect(() => {
    if (isAllMasterFieldCategoriesListSuccess && allMasterFieldCategoriesData) {
      const defaultCategory =
        allMasterFieldCategoriesData[2] || allMasterFieldCategoriesData[0];
      const categories = [
        { label: "All", value: "All" },
        ...allMasterFieldCategoriesData.map((item) => ({
          label: item.masterFieldCategory,
          value: item.id,
        })),
      ];
      setCategoryOptions(categories);
      mapDropdownOptions(
        clientValuationDetailsDataFormConfig,
        "basicDetailSection",
        "category",
        categories,
        "value",
        "label"
      );
      const updatedForm = {
        ...clientForm,
        initialState: {
          ...clientForm.initialState,
          category: defaultCategory?.id || null,
          masterFieldCategory: defaultCategory?.masterFieldCategory || null
        }
      };
      setFormValues({ id: defaultCategory?.id || null });
    }
    let fieldsToHide = ["valfieldName", "ValfieldValue", "ValFieldMergeFieldName", "ReportTemplateID", "ReportTemplateFieldID", "ValfieldId", "Copy Value"];
    const filteredColumns = clientvaluationDetailDataGridConfig.columns.filter(
      (item) => !fieldsToHide.includes(item.name)
    );
    setGridConfig((prevConfig) => ({
      ...prevConfig,
      columns: filteredColumns
    }));
  }, [isAllMasterFieldCategoriesListSuccess, allMasterFieldCategoriesData]);

  useEffect(() => {
    if (isGetClientValuationByReportXmlTempIdSuccess && clientValuationByReportXmlTempIdData) {
      mapDropdownOptions(
        clientValuationDetailsDataFormConfig,
        "basicDetailSection",
        "xmlReportId",
        clientValuationByReportXmlTempIdData,
        "xmlReportId",
        "xmlReportName"
      );
      setXmlReportId(clientValuationByReportXmlTempIdData[0]?.xmlReportId)

    }
  }, [isGetClientValuationByReportXmlTempIdSuccess, clientValuationByReportXmlTempIdData, originOptions, categoryOptions]);

  useEffect(() => {
    if (isGetClientValuationByReportTempIdSuccess && clientValuationByReportTempIdData) {
      mapDropdownOptions(
        clientValuationDetailsDataFormConfig,
        "basicDetailSection",
        "wordDocID",
        clientValuationByReportTempIdData,
        "wordDocID",
        "wordDocPathAndName"
      );

      let updatedForm = { ...clientForm };
      updatedForm.initialState = {
        ...updatedForm.initialState,
        category: categoryOptions[0]?.value,
        originId: originOptions[0]?.value,
        wordDocID: clientValuationByReportTempIdData[0]?.wordDocID || null,
        xmlReportId: clientValuationByReportXmlTempIdData ? clientValuationByReportXmlTempIdData[0]?.xmlReportId : null
      };
      setWordDocPathAndName(clientValuationByReportTempIdData[0]?.wordDocPathAndName);

      setClientForm(updatedForm);

      if (categoryOptions[0]?.value) {
        const requestData = {
          templateid: props.selectedTemplate,
          category: categoryOptions[0]?.value,
          valid: props.valID,
          originId: originOptions[0]?.label
        };
        getAllMergeFieldsData(requestData);
      }
    }
  }, [isGetClientValuationByReportTempIdSuccess, clientValuationByReportTempIdData, originOptions, categoryOptions]);

  // useEffect(() => {
  //   if (ispriorFromCopyFieldsSuccess && priorFromCopyFieldsData) {
  //     // ToastService.success(priorFromCopyFieldsData?.errorMessage)
  //   }
  // }, [ispriorFromCopyFields, ispriorFromCopyFieldsSuccess, priorFromCopyFieldsData])

  const actionHandler = {
    EDIT: handleUpdateClick,
  };

  return (
    <>
      {calculationLoader ?
        <div style={{ height: "42rem" }}>

          <DataLoader
            message={
              isFetchingWordMerge
                ? "Creating Word Merge, Please Wait..."
                : "Processing your request, please hold on a moment…"
            }
          />
        </div>
        :
        <>
          <div className="top-filter-sec">
            <FormCreator
              ref={clientRef}
              config={clientForm}
              onColumnChange={onColumnChange}
            />
            <div className="form-button-group">
              <Buttons
                buttonText={"Show Results"}
                buttonTypeClassName="btn blue-btn w-full"
                onClick={handleShowResultClick}
                isLoading={false}
              />
            </div>
          </div>
          <div
            ref={containerRef}
            className={`filter-based-result table-cols-${gridConfig?.columns?.length}`}
          >
            {calculationLoader ? (
              <>
                <DataLoader
                  message={
                    isFetchingWordMerge
                      ? "Creating Word Merge, Please Wait..."
                      : "Performing Calculation, Please Wait..."
                  }
                />
              </>
            ) : (
              <div className={`${selectedOrigin?.label ? selectedOrigin?.label : selectedOrigin}column `}>
                  <div className="prime-table-sec mapping-field">
                    <div className="card">
                      {
                        isloadingData ? (
                          <DataLoader />
                        ) : dataSource?.length === 0 ? (
                          <NoRecordFound />
                        ) : (
                          <DataTable
                            value={dataSource}
                            scrollable
                            stripedRows
                            selection={selectedRow}
                            selectionMode="single"
                            scrollHeight="400px"
                            editMode="cell"
                            virtualScrollerOptions={{ itemSize: 25 }}
                            tableStyle={{ minWidth: "50rem" }}
                            onSelectionChange={(e) => (setSelectedRow(e.value))}
                            metaKeySelection={true}
                            sortMode="single"
                          >

                            {gridConfig?.columns?.map((item, index) => {
                              return (
                                <Column
                                  key={index}
                                  field={item.fieldName}
                                  sortable
                                  header={item.name}
                                  style={{ width: '20%' }}
                                  body={cellRenderer}
                                  editor={handleFieldEditor}
                                  onCellEditComplete={onCellEditComplete}
                                />
                              );
                            })}
                          </DataTable>
                        )
                      }
                    </div>
                  </div>
              </div>
            )}
 
          </div>

          <div className="action-btn-sec mb-2">
            <div className="form-button-group">
              <Buttons
                buttonText="Copy Prior Val Data"
                buttonTypeClassName="btn dark-btn w-full"
                // isDisable={selectedOrigin?.value == 2 ? false : true}
                isLoading={false}
                onClick={handleCopyValDataClick}
              />
              <Buttons
                buttonText={"Import Liabilities"}
                buttonTypeClassName="btn danger-btn w-full"
                isLoading={false}
                // isDisable={selectedOrigin?.value == 3 ? false : true}
                onClick={handleImportLiabilitysClick}
              />
              <Buttons
                buttonText="Perform Calculation"
                buttonTypeClassName="btn blue-btn"
                onClick={handlePerformCalculation}

              />
                  {/* <Buttons
                buttonText="Export CSV"
                buttonTypeClassName="btn warning-btn"
                onClick={handleExportCsc}

              /> */}
              <Buttons
                buttonText={"Create Word Merge"}
                buttonTypeClassName="btn info-btn w-full"
                isDisable={wordDocPathAndName != null ? false : true}
                isLoading={false}
                onClick={handleCreateMergeClick}
              />
              <Buttons
                buttonText={"manage XML Reports"}
                buttonTypeClassName="btn dark-btn w-full"
                isLoading={false}
                isDisable={XmlReportId != null ? false : true}
                onClick={handleManagePrimeXMLReportClick}
              />
            </div>
          </div>

          <CenterModal
            modalTitle={`Manage XML Report Data`}
            modalSize={"w-55"}
            isOpen={isManageXMLReportPrimeModelOpen}
            onClose={handleCloseModel}
            transition={"grow"}
            className="modal-grid-scroll"
          >
            <div className="view-schema-filed-sec schema-table">
              <ManageXMLReportData XmlReportId={XmlReportId} valId={props.valID} templateId={props.selectedTemplate} isPrime={isManageXMLReportPrimeModelOpen} />
            </div>
          </CenterModal>

          <CenterModal
            modalTitle={`Import Excel`}
            modalSize={"w-85"}
            isOpen={isImportLiabilitysModelOpen}
            onClose={handleCloseImportModel}
            transition={"grow"}
          >
            <ImportLiabilities onClose={handleCloseImportModel} ReportTemplateID={props?.selectedTemplate} valid={props?.valID} />
          </CenterModal>
        </>
      }
    </>
  );
}

ValuationData.propTypes = {
  selectedTemplate: PropTypes.number,
  valID: PropTypes.number,
  clientName: PropTypes.string,
  planYearBegin: PropTypes.string,
  PlanNumber: PropTypes.number,
  reportType: propTypes.string,
  onSuccess: PropTypes.func,
};

export default ValuationData;
